import * as React from 'react';
import isBrowser from '../../../services/isBrowser';

export const Modal = ({ children, active }: {children: any, active: boolean}) => {

    React.useEffect(() => {
        if (!isBrowser() || !active) return;
        document.body.style.overflowY = 'hidden';
        return (() => {
            if (!isBrowser()) return;
            document.body.style.overflowY = 'auto';
        })
    },[active])

    return (<div className={`fixed ${active ? 'left-[0px] opacity-100' : 'left-[100vw] opacity-0'} w-screen duration-500 transition-all h-[calc(100vh-62px)] md:h-[calc(100vh-65px)] z-[300] bg-zinc-600 bg-opacity-20 top-[62px] md:top-[65px]`}>
        <div className="bg-white absolute top-0 bottom-0 left-0 right-0 opacity-95">
            {children}
        </div>
    </div>)
}